// eslint-disable-next-line import/prefer-default-export
export const BopisFilterLabels = {
  PLP: {
    plpTiles: {
      lbl_plp_select_store: 'Select store',
      lbl_plp_select_nearby_store: 'Select store to see what is available near you',
      lbl_plp_change_store: 'Change Store',
      lbl_plp_select_at: 'Pick up at',
    },
  },
};
